<un-message-thread-cover [thread]="thread"></un-message-thread-cover>
<div class="info">
  <div class="name m-b-4">
    <p class="t-small t-medium t-ellipsis">
      {{ thread.name }}
    </p>
    <p class="c-soft t-tiny date">{{ thread.updatedAt | date : 'MMM, dd' }}</p>
  </div>
  <div class="preview">
    @if (cleanText) {
    <p class="t-small t-ellipsis">
      @if (thread.lastMessage?.attachments?.length) {
      <un-icon type="file-text" theem="fill" class="m-r-8 t-tiny"></un-icon>
      }
      {{ cleanText }}
    </p>
    } @if (!cleanText) {
    <p class="t-small t-ellipsis" i18n="@@noMessageYet">No message yet</p>
    } @if ((facade.select$(thread._id) | async)?.unread; as count) {
    <nz-badge
      nzStandalone
      [nzCount]="count"
      nzSize="small"
      [nzShowZero]="false"
    ></nz-badge>
    }
  </div>
</div>
